/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeflyerssizea43Inputs */

const en_placeflyerssizea43 = /** @type {(inputs: Placeflyerssizea43Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A4`)
};

const de_placeflyerssizea43 = /** @type {(inputs: Placeflyerssizea43Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A4`)
};

/**
* | output |
* | --- |
* | "A4" |
*
* @param {Placeflyerssizea43Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placeflyerssizea43 = /** @type {((inputs?: Placeflyerssizea43Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeflyerssizea43Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeflyerssizea43(inputs)
	return de_placeflyerssizea43(inputs)
});
export { placeflyerssizea43 as "placeFlyersSizeA4" }